<template>
  <div class="people">
    <div class="people-header">
      <el-form :inline="true">
        <el-form-item>
          <upload
            id="uploadFile1"
            accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            @httpRequest="uploadFile"
            :multiple="true"
          >
            <el-button
              :disabled="uploadDisabled"
              type="primary"
              @click="uploadStudent($event,1)"
              slot="upload"
            >学者上传</el-button>
            <!-- <el-button  @click="clickUpload" slot="upload" type="primary" size="small">点击上传</el-button> -->
          </upload>
          <upload
            id="uploadFile2"
            accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            @httpRequest="uploadFile"
            :multiple="true"
          >
            <el-button type="success" @click="uploadResult($event,2)" slot="upload">成果上传</el-button>
            <!-- <el-button  @click="clickUpload" slot="upload" type="primary" size="small">点击上传</el-button> -->
          </upload>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-list">
      <div class="table-list-left">
        <h3 class="tac">任务列表</h3>
        <el-table :data="fieldData.list" stripe highlight-current-row style="width: 100%">
          <el-table-column
            :prop="item.prop"
            :type="item.type"
            v-for="(item, index) in fieldData.cloumns"
            :key="'table'+index"
            :label="item.label"
            :width="item.width"
          ></el-table-column>
          <el-table-column label="处理进度" align="center" width="300">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="getDetail1(scope.row)">任务明细</el-button>
              <el-button type="text" size="small" @click="getDetail2(scope.row)">任务资源处理明细</el-button>
              <el-button type="text" size="small" @click="uploadMore(scope.row)">继续导入资源</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :pageSizes="fieldData.pageData.pageSizes"
          :total="fieldData.total"
          :page.sync="fieldData.pagetion.from"
          :limit.sync="fieldData.pagetion.size"
          :layout="fieldData.pageData.layout"
          @pagination="getPage"
        />
      </div>
      <div class="table-list-right">
        <h3 class="tac">任务明细</h3>
        <el-table
          v-loading="detail1.loading"
          :data="detail1.list"
          stripe
          highlight-current-row
          style="width: 100%"
        >
          <el-table-column
            :prop="item.prop"
            :type="item.type"
            v-for="(item, index) in detail1.cloumns"
            :key="'table'+index"
            :label="item.label"
            :width="item.width"
          ></el-table-column>
        </el-table>
        <pagination
          :pageSizes="detail1.pageData.pageSizes"
          :total="detail1.total"
          :page.sync="detail1.pagetion.from"
          :limit.sync="detail1.pagetion.size"
          :layout="detail1.pageData.layout"
          @pagination="getPage"
        />
      </div>
      <div class="table-list-bottom">
        <h3 class="tac">任务资源处理明细</h3>
        <el-table
          v-loading="detail2.loading"
          :data="detail2.list"
          stripe
          highlight-current-row
          style="width: 100%"
        >
          <el-table-column
            :prop="item.prop"
            :type="item.type"
            v-for="(item, index) in detail2.cloumns"
            :key="'table'+index"
            :label="item.label"
            :width="item.width"
          ></el-table-column>
        </el-table>
        <pagination
          :pageSizes="detail2.pageData.pageSizes"
          :total="detail2.total"
          :page.sync="detail2.pagetion.from"
          :limit.sync="detail2.pagetion.size"
          :layout="detail2.pageData.layout"
          @pagination="getPage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import Upload from "@/components/Upload";
import uploadFileAxios from "@/utils/uploadFile";

import {
  batchExpertOrder,
  batchExpertExpert,
  batchExpertResource
} from "@/api/batch";
export default {
  components: {
    Pagination,
    Upload
  },
  name: "batch",
  props: {
    Kid: {
      type: String,
      default: ""
    },
    isHttp: {
      type: String
    }
  },
  data() {
    return {
      user: localStorage.getItem("user"), // user
      orderid: "",
      fieldData: {
        list: [],
        row: {},
        cloumns: [
          { prop: "no", label: "任务编号" },
          { prop: "expertcount", label: "专家数量", width: "80px" }
        ],
        total: 0,
        loading: false,
        pagetion: {
          from: 0,
          size: 10
        }, // 分页情况
        pageData: {
          layout: "sizes, prev, pager, next, jumper", // 分页
          pageSizes: [10] // 每页条数
        }
      },
      detail1: {
        show: false,
        loading: false,
        list: [],
        row: {},
        cloumns: [
          { prop: "name", label: "姓名" },
          { prop: "organization", label: "机构" },
          { prop: "department", label: "部门" },
          { prop: "status", label: "数据状态" }
        ],
        total: 0,
        loading: false,
        pagetion: {
          from: 0,
          size: 10
        }, // 分页情况
        pageData: {
          layout: "sizes, prev, pager, next, jumper", // 分页
          pageSizes: [10] // 每页条数
        }
      },
      detail2: {
        show: false,
        loading: false,
        list: [],
        row: {},
        cloumns: [
          { prop: "no", label: "ID" },
          { prop: "title", label: "标题" },
          { prop: "author", label: "关联学者" },
          { prop: "type", label: "成果类型" },
          { prop: "year", label: "入库时间" },
          { prop: "searchFlag", label: "专家匹配结果" },
          { prop: "claimFlag", label: "认领进度" },
          { prop: "status", label: "数据状态" }
        ],
        total: 0,
        loading: false,
        pagetion: {
          from: 0,
          size: 10
        }, // 分页情况
        pageData: {
          layout: "sizes, prev, pager, next, jumper", // 分页
          pageSizes: [10] // 每页条数
        }
      },
      fileType: 1,
      uploadDisabled: false
    };
  },
  mounted() {
    this.getPage();
  },
  methods: {
    // 获取新的专家列表数据
    uploadMore(item) {
      this.orderid = item.no;
    },
    getDetail1(item) {
      this.fieldData.row = item;
      this.getPage1();
    },
    getDetail2(item) {
      this.fieldData.row = item;
      this.getPage2();
    },
    uploadFile(file) {
      //上传文件
      var form = new FormData(); // FormData 对象
      form.append("myfile", file); // 文件对象
      form.append("dataType", this.fileType == 2 ? "成果" : "专家");
      if (this.fileType == 2) {
        form.append("ordered", 1111);
      }
      uploadFileAxios(form).then(res => {
        this.$message({
          message: res.msg,
          type: res.code == 0 ? "success" : "error"
        });
        if (res.code == 0) {
          this.getPage();
          this.orderid = res.orderid;
        }
      });
    },
    uploadStudent(type) {
      this.fileType = type;
      this.uploadDisabled = true;
      setTimeout(() => {
        this.uploadDisabled = false;
      }, 3000);
    },
    uploadResult(e, type) {
      if (!this.orderid && type == 2) {
        this.$message({
          message: "请先上传学者信息，或者点击下方列表中的继续上传！",
          type: "error"
        });
        e.stopPropagation();
        return;
      }
      this.fileType = type;
      this.uploadDisabled = true;
      setTimeout(() => {
        this.uploadDisabled = false;
      }, 3000);
    },
    getPage({ ...data }) {
      this.fieldData.pagetion.from = data.page || 0;
      this.fieldData.pagetion.size = data.limit || this.fieldData.pagetion.size;
      return this.getTabel();
    },
    getPage1({ ...data }) {
      this.detail1.pagetion.from = data.page || 0;
      this.detail1.pagetion.size = data.limit || this.detail1.pagetion.size;
      this.getTabel1();
    },
    getPage2({ ...data }) {
      this.detail2.pagetion.from = data.page || 0;
      this.detail2.pagetion.size = data.limit || this.detail2.pagetion.size;
      this.getTabel2();
    },
    getTabel() {
      let params = {
        ...this.fieldData.pagetion
      };
      return batchExpertOrder(params).then(res => {
        if (res.code == 0) {
          this.fieldData.list = res.data;
          this.fieldData.total = res.count;
          this.fieldData.row = res.data[0];
        }
      });
    },
    getTabel1() {
      let params = {
        orderid: this.fieldData.row.no,
        ...this.detail1.pagetion
      };
      this.detail1.loading = true;
      batchExpertExpert(params).then(res => {
        if (res.code == 0) {
          this.detail1.list = res.data.orderexpert;
          this.detail1.total = res.count;
          this.detail1.loading = false;
        }
      });
    },
    getTabel2() {
      let params = {
        orderid: this.fieldData.row.no,
        ...this.detail2.pagetion
      };
      this.detail2.loading = true;
      batchExpertResource(params).then(res => {
        if (res.code == 0) {
          this.detail2.loading = false;
          this.detail2.list = res.data;
          this.detail2.total = res.count;
        }
      });
    }
  },
  computed: {},
  watch: {
    isHttp: {
      handler(val) {
        if (val == 4) {
          this.getPage().then(res => {
            this.getPage1();
            this.getPage2();
          });
        }
      }
    }
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
.people {
  padding: 20px 0;
  .el-button {
    padding: 12px 20px;
  }
  &-header {
    text-align: center;
  }
  .table-list {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    > div {
      width: 48%;
    }
    > div.table-list-bottom {
      width: 100%;
    }
    .el-button {
      padding: 0;
    }
    button + button {
      margin-left: 20px;
    }
  }
  /deep/.cell {
  }
}
</style>



// WEBPACK FOOTER //
// src/view/center/menu/batch.vue